import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import { loadPublishedPostById, clearPost } from 'state/actions/posts'
import { loadGroup } from 'state/actions/groups'

const component = universal(() => import('./BookCairDesktopPage'))

class AsyncBookCairDesktopLivePage extends AsyncPage {
  nonav = true

  constructor() {
    super({
      title: 'navigation./book-cair',
      pageComponent: component,
      isChromeless: true,
    })
  }

  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    // try {
    //   dispatch(clearPost())
    // } catch (e) {
    //   log.error(e)
    // }
    // try {
    //   const { location: { payload: { post: postId } } } = getState()
    //   if (!postId) return
    //   const post = await loadPublishedPostById({ _id: postId })(dispatch, getState, opts)
    //   const group = post && post.group && post.group.group && (post.group.group._id || post.group.group)
    //   if (group) {
    //     await loadGroup({ _id: group })(dispatch, getState, opts)
    //   }
    // } catch (err) {
    //   log.error(err)
    // }
  }
}

export default new AsyncBookCairDesktopLivePage()
